export default "__VITE_ASSET__DdCFCW7d__"